<template>
  <!-- ======= Cta Section ======= -->
  <section id="cta" class="cta">
    <div class="container">
      <div class="row">
        <div class="col-lg-9 text-center text-lg-start">
          <h3>Let's Build Something Great Together!</h3>
          <p>
            Whether you have a specific project in mind or just want to learn
            more about our capabilities, we would love to connect with you. Our
            team of experts is ready to help you build a powerful and effective
            web presence that can drive your business forward. To get started,
            simply fill out our contact form or give us a call. We look forward
            to hearing from you!
          </p>
        </div>
        <div class="col-lg-3 cta-btn-container text-center">
          <a
            class="cta-btn align-middle"
            :href="`mailto:${corporateData.email}?subject=${corporateData.supportEmailData.supportEmailSubject}&body=${corporateData.supportEmailData.supportEmailBody}`"
            >Email us</a
          >
        </div>
      </div>
    </div>
  </section>
  <!-- End Cta Section -->
</template>

<script>
import { CORPORATE_DATA } from "../../constants";

export default {
  data() {
    return {
      corporateData: CORPORATE_DATA,
    };
  },
};
</script>

<style lang="scss" scoped>
/*--------------------------------------------------------------
# Cta
--------------------------------------------------------------*/
.cta {
  background: $mainLightBlue;
  padding: 80px 0;
}

.cta h3 {
  color: $mainWhite;
  font-size: 28px;
  font-weight: 700;
}

.cta p {
  color: $mainWhite;
}

.cta .cta-btn {
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1px;
  display: inline-block;
  padding: 10px 30px;
  border-radius: 2px;
  transition: 0.5s;
  margin: 10px;
  border: 2px solid $mainWhite;
  color: $mainWhite;
  border-radius: 4px;
}

.cta .cta-btn:hover {
  background: $mainWhite;
  color: #5cb874;
}

@media (max-width: 1024px) {
  .cta {
    background-attachment: scroll;
  }
}

@media (min-width: 769px) {
  .cta .cta-btn-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>